import { render, staticRenderFns } from "./EditorField.vue?vue&type=template&id=ede19814&"
import script from "./EditorField.vue?vue&type=script&lang=ts&"
export * from "./EditorField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports